// Finding categories — D20 / 02 §3. Array order is the display order of dossier sections.
// Правни · Възможности · Актуалност · Скорост и техническо · Видимост и доверие
export const FINDING_CATEGORIES = [
    'legal',
    'capabilities',
    'freshness',
    'performance',
    'visibility',
];
//# sourceMappingURL=categories.js.map